import { IssuesList } from './IssuesList';
import { IssueVisibilityType } from '@sonar-software/sonar-issues';
import React from 'react';
export const VisibleIssuesList = ({ hideActions, limit }) => React.createElement(IssuesList, { hideActions: hideActions, limit: limit, visibility: IssueVisibilityType.Visible });
